import {fetchJSON} from './remote-data.js';

// Reuse only validated public widget responses within this tab. Short-lived
// snapshots prevent a return visit from replacing settled cards with skeletons.
const lifetime = 60_000;
const prefix = 'tiwb-public-data:';

export async function cachedPublicJSON(url, decode, options = {}) {
    const key = prefix + url;
    try {
        const entry = JSON.parse(sessionStorage.getItem(key));
        const age = Date.now() - entry?.savedAt;
        if (entry && age >= 0 && age < lifetime) return decode(entry.value);
    } catch (_) { /* Unavailable storage or invalid cache: use the network. */ }

    const value = await fetchJSON(url, options);
    const result = decode(value);
    try { sessionStorage.setItem(key, JSON.stringify({savedAt: Date.now(), value})); } catch (_) {}
    return result;
}
